import React, { useEffect, useLayoutEffect, useState } from "react";
import styles from "./MainPage.module.css";
import { Header, Sidebar } from "components/layout";
import { MenuItem } from "react-pro-sidebar";
import { Logout, AdminPanelSettings, TextSnippetOutlined, AccountCircleOutlined,
    TabletAndroidOutlined, AppsOutlined, MenuOutlined,
    NumbersOutlined, Lock, ShoppingBagOutlined,
    SettingsOutlined} from "@mui/icons-material";
import { Routes, Route, NavLink, Outlet, useLocation, Navigate } from "react-router-dom";
import { useGetAppsQuery } from "services/data/DataService";
import { useDispatch, useSelector } from "react-redux";
import { logout } from "store/auth/authSlice";
import { FullScreenLoader } from "components/loaders";
import { FullScreenError } from "components/errors";
import { IconButton } from "components/buttons";
import { useNavigate } from 'react-router-dom';
import DevicePage from "../DevicePage";
import LicencePage from "../LicencePage";
import SettingPage from "../SettingPage";
import ReportPage from "../ReportPage";
import { SearchBar } from "components/forms";
import ToolbarManager from "../ToolbarManager";



const MainPage = () => {

    const [collapsedBar, setCollapsedBar] = useState(false);
    const [activeToolbar, setActiveToolbar] = useState(null);

    const {userInfo, accessToken, rememberUser, error} = useSelector(state => state.auth);
    const { selectedDevice, activeDetails } = useSelector(state => state.device);
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const location = useLocation();

    useEffect(() => { 
        if(error || (!accessToken && !rememberUser)) {
            dispatch(logout());
        }
    }, [accessToken]);

    const getDeviceUrl = () => {
        if(selectedDevice && activeDetails) return `/devices/${selectedDevice.id}/${activeDetails.value}`;
        return '/devices';
    };

    const onLogout = () => {
        dispatch(logout());
    };

    
    /*if(error) {
        return <FullScreenError />;
    }*/

    if (!accessToken) {
        return <FullScreenLoader />;
    }
    
    const headerItems =
        <>
            <IconButton
                text="Выйти из кабинета"
                iconCmp={<Logout />}
                handler={onLogout}
            />
        </>;

    return (
        <div className={styles.wrapper}>
            <div className={styles.menuWrapper}>
                <Sidebar
                    collapsed={collapsedBar}
                    className={styles.menu}    
                >
                    <MenuItem
                        icon={<MenuOutlined />}
                        onClick={ () => setCollapsedBar(!collapsedBar) }
                    >
                        <h1>Кабинет</h1> 
                    </MenuItem>
                    <MenuItem 
                        icon={< TabletAndroidOutlined />}
                        component={<NavLink to={getDeviceUrl()} className="link" />}
                    >
                        Кассы
                    </MenuItem>
                    <MenuItem
                        icon={< Lock />}
                        component={<NavLink to="/licences" className="link" />}
                    >
                        Лицензии
                    </MenuItem>
                    <MenuItem
                        icon={< TextSnippetOutlined />}
                        component={<NavLink to="/reports" className="link" />}
                    >
                        Отчёты
                    </MenuItem>
                    <MenuItem
                        icon={< SettingsOutlined />}
                        component={<NavLink to="/settings" className="link" />}
                    >
                        Настройки
                    </MenuItem>
                </Sidebar>
            </div>  
            <div className={styles.contentWrapper}>
                <Header
                    //search={<ToolbarManager type={activeToolbar}/>}
                    user={userInfo?.userName}
                    items={headerItems}
                />
                <section className={styles.content}>
                    <Routes>
                        
                        <Route path="/" element={<Navigate to="/devices" replace />} />
                        <Route path='*' element={<h2>Страница не найдена!</h2>} />   

                        <Route path="devices/*" element={<DevicePage setActiveToolbar={setActiveToolbar}/>} />
                        <Route path="licences" element={<LicencePage setActiveToolbar={setActiveToolbar} />} />
                        <Route path="reports" element={<ReportPage setActiveToolbar={setActiveToolbar} />} />
                        <Route path="settings" element={<SettingPage setActiveToolbar={setActiveToolbar} />} />
                    </Routes>
                </section>
            </div>
        </div>
        
    );
};

export default MainPage;